// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2023 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import Layout from '@/layout';
var productRouter = {
  path: '/product',
  component: Layout,
  redirect: '/product/index',
  name: 'Product',
  meta: {
    title: '商品',
    icon: 'clipboard'
  },
  children: [{
    path: 'list',
    component: function component() {
      return import('@/views/product/index');
    },
    name: 'ProductIndex',
    meta: {
      title: '商品审核',
      icon: ''
    }
  },
  //  {
  //   path: 'regulate',
  //   component: () => import('@/views/product/regulate'),
  //   name: 'ProductRegulate',
  //   meta: { title: '商品管理', icon: '' },
  // },
  {
    path: 'category',
    component: function component() {
      return import('@/views/product/category/index');
    },
    name: 'ProductCategory',
    meta: {
      title: '商品分类',
      icon: ''
    }
  }, {
    //id:商品id，isDisabled：是否能编辑(1不能，2能)，isCopy：是否是采集商品(1是，2不是)
    path: 'regulate/creatProduct/:id?/:isDisabled/:isCopy?',
    component: function component() {
      return import('@/views/product/creatProduct/index');
    },
    name: 'creatProduct',
    meta: {
      title: '商品添加',
      noCache: true,
      activeMenu: "/product/regulate",
      keepAlive: true
    },
    hidden: true
  }, {
    //id:商品id，isDisabled：是否能编辑(1不能，2能)，isCopy：是否是采集商品(1是，2不是)
    path: 'regulate/creatProductpack/:id?/:isDisabled/:isCopy?',
    component: function component() {
      return import('@/views/product/creatProductpack/index');
    },
    name: 'creatProductpack',
    meta: {
      title: '礼包添加',
      noCache: true,
      activeMenu: "/product/giftpack",
      keepAlive: true
    },
    hidden: true
  }, {
    path: 'comment',
    component: function component() {
      return import('@/views/product/comment/index');
    },
    name: 'ProductComment',
    meta: {
      title: '商品评论',
      icon: ''
    }
  }, {
    path: 'brand',
    component: function component() {
      return import('@/views/product/brand/index');
    },
    name: 'ProductBrand',
    meta: {
      title: '品牌管理',
      icon: ''
    }
  }, {
    path: 'guarantee',
    component: function component() {
      return import('@/views/product/guarantee/index');
    },
    name: 'ProductGuarantee',
    meta: {
      title: '保障服务',
      icon: ''
    }
  }, {
    path: 'tag',
    component: function component() {
      return import('@/views/product/tag/index');
    },
    name: 'ProductTag',
    meta: {
      title: '商品标签',
      icon: ''
    }
  }, {
    path: 'attr',
    component: function component() {
      return import('@/views/product/attr/index');
    },
    name: 'ProductAttr',
    meta: {
      title: '商品规格',
      icon: ''
    }
  }, {
    path: 'productManage',
    component: function component() {
      return import('@/views/product/indexhook');
    },
    name: 'productManage',
    meta: {
      title: '商品管理',
      icon: ''
    },
    alwaysShow: true,
    children: [{
      path: 'regulate',
      component: function component() {
        return import('@/views/product/regulate');
      },
      name: 'ProductRegulate',
      meta: {
        title: '商品发布',
        icon: ''
      }
    }, {
      path: 'giftpack',
      component: function component() {
        return import('@/views/product/giftpack');
      },
      name: 'ProductGiftpack',
      meta: {
        title: '商品礼包',
        icon: ''
      }
    }, {
      path: 'brokerage',
      component: function component() {
        return import('@/views/product/brokerage/list');
      },
      name: 'ProductBrokerage',
      meta: {
        title: '商品佣金',
        icon: ''
      }
    }, {
      path: 'brokerageindex/:id/',
      component: function component() {
        return import('@/views/product/brokerage/index');
      },
      name: 'ProductBrokerageIndex',
      meta: {
        title: '商品佣金配置',
        icon: ''
      },
      hidden: true
    }, {
      // path: 'regulate/creatProduct/:id?/:isDisabled/:isCopy?',
      path: 'coordinationindex/:id/',
      component: function component() {
        return import('@/views/product/coordination/index');
      },
      name: 'ProductCoordinationIndex',
      meta: {
        title: '商品配套配置',
        icon: ''
      },
      hidden: true
    }, {
      path: 'coordination',
      component: function component() {
        return import('@/views/product/coordination/list');
      },
      name: 'ProductCoordination',
      meta: {
        title: '商品配套',
        icon: ''
      }
    }, {
      path: 'matching',
      component: function component() {
        return import('@/views/product/matching/index');
      },
      name: 'ProductMatching',
      meta: {
        title: '配套配置',
        icon: ''
      }
    }, {
      path: 'commissioned',
      component: function component() {
        return import('@/views/product/commissioned/index');
      },
      name: 'ProductCommissioned',
      meta: {
        title: '佣金配置',
        icon: ''
      }
    }, {
      path: 'extend',
      component: function component() {
        return import('@/views/product/extend/index');
      },
      name: 'extend',
      meta: {
        title: '商品扩展',
        icon: ''
      }
    }]
  }, {
    path: 'materials',
    name: 'MerchantMaterials',
    component: function component() {
      return import('@/views/product/materials');
    },
    meta: {
      title: '产品物料',
      icon: ''
    }
  }, {
    path: 'freightSet',
    component: function component() {
      return import('@/views/product/freightSet');
    },
    name: 'freightSet',
    meta: {
      title: '运费模板',
      noCache: true
    }
  }]
};
export default productRouter;